module.exports = __webpack_public_path__ + "static/media/scratch-off-market-combo.a000c91b.svg";